import React from 'react'

import { Picture } from './UserIcon.styles'
const UserIcon = ({ image, radius, handle }) => {
    return (
        <Picture radius={radius}><img src={image} alt={handle !== undefined ? handle : 'user-picture'} /></Picture>
    )
}

export default UserIcon